import 'react';
import { BsBoxArrowDown } from '@react-icons/all-files/bs/BsBoxArrowDown';
import { BsBoxArrowUp } from '@react-icons/all-files/bs/BsBoxArrowUp';
import { ButtonGroupField, ToggleField } from '@bucketplace/commerce-admin-ui';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import '../../contexts/internal/StickyContext.js';
import '../../contexts/internal/EditorContext.js';
import '../../components/Canvas/Canvas.style.js';
import '../../components/Canvas/PreviewModeContainer.js';
import '../../components/Duration/DurationInput.js';
import 'react-hook-form';
import '../../components/FieldItem.js';
import '../../components/FormGroup/FormGroup.js';
import '../../components/FormGroup/LogDataFormGroup.js';
import '../../components/Header/index.js';
import '../../components/Input/ColorPickerField/index.js';
import '../../components/Input/URLInput.js';
import '../../components/Inspector/Inspector.js';
import '../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import '@bucketplace/bucket-log';
import 'react-dom';
import '../../components/Tooltip/Tooltip.js';
import '../../components/Toolbar/Toolbar.style.js';
import '../../components/TreeList/Draggable.js';
import '../../components/EditorPlaceholder/EditorPlaceholder.js';
import { FormContent } from '../../components/FormContent.js';
import { InspectorFormProvider } from '../../components/InspectorFormProvider.js';

var BUTTON_PLACEMENT_OPTIONS = [{
  text: jsx(BsBoxArrowUp, null),
  value: 'top'
}, {
  text: jsx(BsBoxArrowDown, null),
  value: 'bottom'
}];
function AccordionInspector(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  return jsx(InspectorFormProvider, {
    value: value,
    onChange: onChange
  }, jsx(FormContent, {
    header: "\uBC84\uD2BC \uC704\uCE58"
  }, jsx(ButtonGroupField, {
    name: "buttonPlacement",
    width: "100%",
    options: BUTTON_PLACEMENT_OPTIONS
  })), jsx(FormContent, {
    header: "\uCD5C\uCD08 \uD3BC\uCE68 \uC0C1\uD0DC"
  }, jsx(ToggleField, {
    name: "initialExpanded"
  })), jsx(FormContent, {
    header: "\uC0B4\uC9DD \uBCF4\uC5EC\uC8FC\uAE30"
  }, jsx(ToggleField, {
    name: "peekable"
  })));
}

export { AccordionInspector };
//# sourceMappingURL=Accordion.Inspector.js.map
